import {
  ENTITY_GROUP_CODE,
  PERMISSION_VALUE,
  SUMMARY_GROUP_CODE,
} from "src/configs/constant";
import { NAME as EXPORT_REDUCER } from "src/modules/export/reducers/export";
import { NAME as EXPORT_PRINT_REDUCER } from "src/modules/export/reducers/export-print";
import { NAME as IMPORT_REDUCER } from "src/modules/import/reducers/import";
import { NAME as IMPORT_PRINT_REDUCER } from "src/modules/import/reducers/import-print";
import { NAME as INVENTORY_ADJUSTMENT_REDUCER } from "src/modules/inventory/reducers/inventory-adjustment";
import { NAME as INVENTORY_CANCEL_REDUCER } from "src/modules/inventory/reducers/inventory-cancel";
import { NAME as INVENTORY_CHECK_REDUCER } from "src/modules/inventory/reducers/inventory-check";
import { NAME as INVENTORY_SLIP_REDUCER } from "src/modules/inventory/reducers/inventory-slip";
import { NAME as INVENTORY_SLIP_INSTANT_REDUCER } from "src/modules/inventory/reducers/inventory-slip-instant";
import { NAME as PURCHASE_PROPOSAL_FORM_REDUCER } from "src/modules/purchase_proposal_form/reducers/purchase-proposal-form";
import { NAME as PURCHASE_PROPOSAL_FORM_PRINT_REDUCER } from "src/modules/purchase_proposal_form/reducers/purchase-proposal-form-print";
import { NAME as SUMMARY_CANCELLATION_REDUCER } from "src/modules/summary/reducers/cancellation";
import { NAME as SUMMARY_CANCELLATION_DETAIL_REDUCER } from "src/modules/summary/reducers/cancellation-detail";
import { NAME as SUMMARY_EXPORT_REDUCER } from "src/modules/summary/reducers/export";
import { NAME as SUMMARY_EXPORT_DETAIL_REDUCER } from "src/modules/summary/reducers/export-detail";
import { NAME as SUMMARY_IMPORT_REDUCER } from "src/modules/summary/reducers/import";
import { NAME as SUMMARY_IMPORT_DETAIL_REDUCER } from "src/modules/summary/reducers/import-detail";
import { NAME as SUMMARY_INVENTORY_REDUCER } from "src/modules/summary/reducers/inventory";
import { NAME as SUMMARY_INVENTORY_ADJUSTMENT_REDUCER } from "src/modules/summary/reducers/inventory-adjustment";
import { NAME as SUMMARY_ORDER_REDUCER } from "src/modules/summary/reducers/order";
import { NAME as SUMMARY_TRANSFER_REDUCER } from "src/modules/summary/reducers/transfer";

export const Profile = {
  _: {
    required: {
      code: ENTITY_GROUP_CODE.ALL,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Thông tin cá nhân",
    path: "/profile",
  },
};

//#region Báo cáo
export const Summary = {
  Dashboard: {
    required: {
      code: SUMMARY_GROUP_CODE.ALL,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Thống Kê",
    path: "/dashboard",
  },
  Order: {
    required: {
      code: SUMMARY_GROUP_CODE.ALL,
      permission: PERMISSION_VALUE.READ,
    },
    reducer: SUMMARY_ORDER_REDUCER,
    icon: "",
    name: "Tổng Hợp Đặt Hàng",
    path: "/summary/order",
  },
  Import: {
    required: {
      code: SUMMARY_GROUP_CODE.ALL,
      permission: PERMISSION_VALUE.READ,
    },
    reducer: SUMMARY_IMPORT_REDUCER,
    icon: "",
    name: "Tổng Hợp Nhập Hàng",
    path: "/summary/import",
  },
  ImportDetail: {
    required: {
      code: SUMMARY_GROUP_CODE.ALL,
      permission: PERMISSION_VALUE.READ,
    },
    reducer: SUMMARY_IMPORT_DETAIL_REDUCER,
    icon: "",
    name: "Chi Tiết Nhập Hàng",
    path: "/summary/import-detail",
  },
  Export: {
    required: {
      code: SUMMARY_GROUP_CODE.ALL,
      permission: PERMISSION_VALUE.READ,
    },
    reducer: SUMMARY_EXPORT_REDUCER,
    icon: "",
    name: "Tổng Hợp Xuất Hàng",
    path: "/summary/export",
  },
  ExportDetail: {
    required: {
      code: SUMMARY_GROUP_CODE.ALL,
      permission: PERMISSION_VALUE.READ,
    },
    reducer: SUMMARY_EXPORT_DETAIL_REDUCER,
    icon: "",
    name: "Chi Tiết Xuất Hàng",
    path: "/summary/export-detail",
  },
  ImportRaw: {
    required: {
      code: SUMMARY_GROUP_CODE.ALL,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Tổng Hợp Nhập NVL Sơ Chế",
    path: "/summary/import-raw",
  },
  ImportRawDetail: {
    required: {
      code: SUMMARY_GROUP_CODE.ALL,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Chi Tiết Nhập NVL Sơ Chế",
    path: "/summary/import-raw-detail",
  },
  ExportRaw: {
    required: {
      code: SUMMARY_GROUP_CODE.ALL,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Tổng Hợp Xuất NVL Sơ Chế",
    path: "/summary/export-raw",
  },
  ExportRawDetail: {
    required: {
      code: SUMMARY_GROUP_CODE.ALL,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Chi Tiết Xuất NVL Sơ Chế",
    path: "/summary/export-raw-detail",
  },
  Transfer: {
    required: {
      code: SUMMARY_GROUP_CODE.ALL,
      permission: PERMISSION_VALUE.READ,
    },
    reducer: SUMMARY_TRANSFER_REDUCER,
    icon: "",
    name: "Tổng Hợp Hàng Luân Chuyển",
    path: "/summary/transfer",
  },
  Cancellation: {
    required: {
      code: SUMMARY_GROUP_CODE.ALL,
      permission: PERMISSION_VALUE.READ,
    },
    reducer: SUMMARY_CANCELLATION_REDUCER,
    icon: "",
    name: "Tổng Hợp Hủy Hàng",
    path: "/summary/cancellation",
  },
  CancellationDetail: {
    required: {
      code: SUMMARY_GROUP_CODE.ALL,
      permission: PERMISSION_VALUE.READ,
    },
    reducer: SUMMARY_CANCELLATION_DETAIL_REDUCER,
    icon: "",
    name: "Chi Tiết Hủy Hàng",
    path: "/summary/cancellation-detail",
  },
  Inventory: {
    required: {
      code: SUMMARY_GROUP_CODE.ALL,
      permission: PERMISSION_VALUE.READ,
    },
    reducer: SUMMARY_INVENTORY_REDUCER,
    icon: "",
    name: "Tổng Hợp Kiểm Kho",
    path: "/summary/inventory",
  },
  InventoryAdjustment: {
    required: {
      code: SUMMARY_GROUP_CODE.ALL,
      permission: PERMISSION_VALUE.READ,
    },
    reducer: SUMMARY_INVENTORY_ADJUSTMENT_REDUCER,
    icon: "",
    name: "Điều chỉnh lượng tồn kho",
    path: "/summary/inventory-adjustment",
  },
};
//#endregion

//#region Tồn kho
export const Inventory = {
  Check: {
    List: {
      required: {
        code: ENTITY_GROUP_CODE.INVENTORY_SLIP,
        permission: PERMISSION_VALUE.READ,
      },
      reducer: INVENTORY_CHECK_REDUCER,
      icon: "",
      name: "DS kiểm kho",
      path: "/inventory-check/list",
    },
    Create: {
      required: {
        code: ENTITY_GROUP_CODE.INVENTORY_SLIP,
        permission: PERMISSION_VALUE.CREATE,
      },
      icon: "",
      name: "Tạo phiếu kiểm kho",
      path: "/inventory-check/form",
    },
    Update: {
      required: {
        code: ENTITY_GROUP_CODE.INVENTORY_SLIP,
        permission: PERMISSION_VALUE.UPDATE,
      },
      icon: "",
      name: "Sửa phiếu kiểm kho",
      path: "/inventory-check/form/:code",
    },
  },
  DinhMucTonKho: {
    List: {
      required: {
        code: ENTITY_GROUP_CODE.DINH_MUC_TON_KHO,
        permission: PERMISSION_VALUE.READ,
      },
      icon: "",
      name: "DS định mức tồn kho",
      path: "/dinh-muc-ton-kho/list",
    },
  },
  Slip: {
    List: {
      required: {
        code: ENTITY_GROUP_CODE.BACKLOG_SLIP,
        permission: PERMISSION_VALUE.READ,
      },
      reducer: INVENTORY_SLIP_REDUCER,
      icon: "",
      name: "DS tồn kho",
      path: "/inventory-slip/list",
    },
    Instant: {
      required: {
        code: ENTITY_GROUP_CODE.BACKLOG_SLIP,
        permission: PERMISSION_VALUE.READ,
      },
      reducer: INVENTORY_SLIP_INSTANT_REDUCER,
      icon: "",
      name: "DS tồn kho tức thời",
      path: "/inventory-slip/instant",
    },
  },
  Adjustment: {
    List: {
      required: {
        code: ENTITY_GROUP_CODE.INVENTORY_SLIP,
        permission: PERMISSION_VALUE.READ,
      },
      reducer: INVENTORY_ADJUSTMENT_REDUCER,
      icon: "",
      name: "Điều chỉnh lượng tồn kho",
      path: "/inventory-adjustment/list",
    },
  },
  Return: {
    List: {
      required: {
        code: ENTITY_GROUP_CODE.RETURN_SLIP,
        permission: PERMISSION_VALUE.READ,
      },
      icon: "",
      name: "DS phiếu trả hàng",
      path: "/inventory-return/list",
    },
    Create: {
      required: {
        code: ENTITY_GROUP_CODE.RETURN_SLIP,
        permission: PERMISSION_VALUE.CREATE,
      },
      icon: "",
      name: "Tạo phiếu trả hàng",
      path: "/inventory-return/form",
    },
    Update: {
      required: {
        code: ENTITY_GROUP_CODE.RETURN_SLIP,
        permission: PERMISSION_VALUE.UPDATE,
      },
      icon: "",
      name: "Sửa phiếu trả hàng",
      path: "/inventory-return/form/:id",
    },
  },
  Cancel: {
    List: {
      required: {
        code: ENTITY_GROUP_CODE.CANCEL_SLIP,
        permission: PERMISSION_VALUE.READ,
      },
      reducer: INVENTORY_CANCEL_REDUCER,
      icon: "",
      name: "DS phiếu hủy hàng",
      path: "/inventory-cancel/list",
    },
    Create: {
      required: {
        code: ENTITY_GROUP_CODE.CANCEL_SLIP,
        permission: PERMISSION_VALUE.CREATE,
      },
      icon: "",
      name: "Tạo phiếu hủy hàng",
      path: "/inventory-cancel/form",
    },
    Update: {
      required: {
        code: ENTITY_GROUP_CODE.CANCEL_SLIP,
        permission: PERMISSION_VALUE.UPDATE,
      },
      icon: "",
      name: "Sửa phiếu hủy hàng",
      path: "/inventory-cancel/form/:id",
    },
    Approval: {
      required: {
        code: ENTITY_GROUP_CODE.CANCEL_SLIP,
        permission: PERMISSION_VALUE.READ,
      },
      icon: "",
      name: "Thông tin phiếu hủy hàng",
      path: "/inventory-cancel/approval/:id",
    },
  },
  EndOfMonthCheck: {
    List: {
      required: {
        code: ENTITY_GROUP_CODE.INVENTORY_SLIP,
        permission: PERMISSION_VALUE.READ,
      },
      reducer: INVENTORY_CHECK_REDUCER,
      icon: "",
      name: "DS kiểm kho cuối tháng",
      path: "/inventory-end-of-month-check/list",
    },
    Create: {
      required: {
        code: ENTITY_GROUP_CODE.INVENTORY_SLIP,
        permission: PERMISSION_VALUE.CREATE,
      },
      icon: "",
      name: "Tạo kiểm kho cuối tháng",
      path: "/inventory-end-of-month-check/form",
    },
    Update: {
      required: {
        code: ENTITY_GROUP_CODE.INVENTORY_SLIP,
        permission: PERMISSION_VALUE.UPDATE,
      },
      icon: "",
      name: "Sửa kiểm kho cuối tháng",
      path: "/inventory-end-of-month-check/form/:id",
    },
  },
};
//#endregion

//#region Phiếu đề xuất
export const Solution = {
  Quantitative: {
    required: {
      code: ENTITY_GROUP_CODE.PURCHASE_PROPOSAL_FORM,
      permission: PERMISSION_VALUE.READ,
    },
    reducer: PURCHASE_PROPOSAL_FORM_REDUCER,
    icon: "",
    name: "DS phiếu cập nhật định lượng",
    path: "/solution/quantitative-list",
  },
  List: {
    required: {
      code: ENTITY_GROUP_CODE.PURCHASE_PROPOSAL_FORM,
      permission: PERMISSION_VALUE.READ,
    },
    reducer: PURCHASE_PROPOSAL_FORM_REDUCER,
    icon: "",
    name: "DS phiếu đề xuất đặt hàng",
    path: "/solution/list",
  },
  Create: {
    required: {
      code: ENTITY_GROUP_CODE.PURCHASE_PROPOSAL_FORM,
      permission: PERMISSION_VALUE.CREATE,
    },
    icon: "",
    name: "Tạo phiếu đề xuất đặt hàng",
    path: "/solution/form",
  },
  Update: {
    required: {
      code: ENTITY_GROUP_CODE.PURCHASE_PROPOSAL_FORM,
      permission: PERMISSION_VALUE.UPDATE,
    },
    icon: "",
    name: "Sửa phiếu đề xuất đặt hàng",
    path: "/solution/form/:code",
  },
  Print: {
    required: {
      code: ENTITY_GROUP_CODE.PURCHASE_PROPOSAL_FORM,
      permission: PERMISSION_VALUE.READ,
    },
    reducer: PURCHASE_PROPOSAL_FORM_PRINT_REDUCER,
    icon: "",
    name: "In phiếu đề xuất",
    path: "/solution/print",
  },
  Transfer: {
    required: {
      code: ENTITY_GROUP_CODE.PURCHASE_PROPOSAL_FORM,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "DS Phiếu Luân Chuyển",
    path: "/solution/transfer/list",
  },
  TransferCreate: {
    required: {
      code: ENTITY_GROUP_CODE.PURCHASE_PROPOSAL_FORM,
      permission: PERMISSION_VALUE.CREATE,
    },
    icon: "",
    name: "Tạo Phiếu luân chuyển",
    path: "/solution/transfer/form",
  },
  TransferUpdate: {
    required: {
      code: ENTITY_GROUP_CODE.PURCHASE_PROPOSAL_FORM,
      permission: PERMISSION_VALUE.CREATE,
    },
    icon: "",
    name: "Sửa Phiếu luân chuyển",
    path: "/solution/transfer/form/:id",
  },
};
//#endregion

//#region Xuất hàng
export const Export = {
  List: {
    required: {
      code: ENTITY_GROUP_CODE.EXPORT_SLIP,
      permission: PERMISSION_VALUE.READ,
    },
    reducer: EXPORT_REDUCER,
    icon: "",
    name: "DS phiếu xuất hàng",
    path: "/export/list",
  },
  Create: {
    required: {
      code: ENTITY_GROUP_CODE.EXPORT_SLIP,
      permission: PERMISSION_VALUE.CREATE,
    },
    icon: "",
    name: "Tạo phiếu xuất hàng",
    path: "/export/form",
  },
  Update: {
    required: {
      code: ENTITY_GROUP_CODE.EXPORT_SLIP,
      permission: PERMISSION_VALUE.UPDATE,
    },
    icon: "",
    name: "Sửa phiếu xuất hàng",
    path: "/export/form/:id",
  },
  Print: {
    required: {
      code: ENTITY_GROUP_CODE.EXPORT_SLIP,
      permission: PERMISSION_VALUE.UPDATE,
    },
    reducer: EXPORT_PRINT_REDUCER,
    icon: "",
    name: "In phiếu xuất hàng",
    path: "/export/print",
  },
};
//#endregion

//#region Nhập hàng
export const Import = {
  Material: {
    List: {
      required: {
        code: ENTITY_GROUP_CODE.PURCHASE_SLIP,
        permission: PERMISSION_VALUE.READ,
      },
      reducer: IMPORT_REDUCER,
      icon: "",
      name: "DS đơn nhập hàng",
      path: "/import/list",
    },
    Create: {
      required: {
        code: ENTITY_GROUP_CODE.PURCHASE_SLIP,
        permission: PERMISSION_VALUE.CREATE,
      },
      icon: "",
      name: "Tạo phiếu nhập nguyên vật liệu",
      path: "/import/form",
    },
    Update: {
      required: {
        code: ENTITY_GROUP_CODE.PURCHASE_SLIP,
        permission: PERMISSION_VALUE.UPDATE,
      },
      icon: "",
      name: "Sửa phiếu nhập nguyên vật liệu",
      path: "/import/form/:id",
    },
    Print: {
      required: {
        code: ENTITY_GROUP_CODE.PURCHASE_SLIP,
        permission: PERMISSION_VALUE.READ,
      },
      reducer: IMPORT_PRINT_REDUCER,
      icon: "",
      name: "In phiếu nhập",
      path: "/import/print",
    },
  },
  OutsideMaterial: {
    List: {
      required: {
        code: ENTITY_GROUP_CODE.PURCHASE_SLIP,
        permission: PERMISSION_VALUE.READ,
      },
      reducer: IMPORT_REDUCER,
      icon: "",
      name: "DS đơn đặt hàng mua ngoài",
      path: "/import/outside-list",
    },
    Create: {
      required: {
        code: ENTITY_GROUP_CODE.PURCHASE_SLIP,
        permission: PERMISSION_VALUE.CREATE,
      },
      icon: "",
      name: "Tạo đơn đặt hàng mua ngoài",
      path: "/import/outside-form",
    },
    Update: {
      required: {
        code: ENTITY_GROUP_CODE.PURCHASE_SLIP,
        permission: PERMISSION_VALUE.UPDATE,
      },
      icon: "",
      name: "Sửa đơn đặt hàng mua ngoài",
      path: "/import/outside-form/:id",
    },
  },
};
//#endregion

//#region Nguyên vật liệu
export const Material = {
  List: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "DS nguyên vật liệu",
    path: "/material/list",
  },
  Update: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Sửa nguyên vật liệu",
    path: "/material/:code",
  },
  PriceUpdateReport: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Báo cáo điều chỉnh giá NVL",
    path: "/material/price-update-report",
  },
  Industry: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "DS ngành nguyên vật liệu",
    path: "/material/industry",
  },
  Category: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "DS nhóm nguyên vật liệu",
    path: "/material/category",
  },
  Type: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "DS loại nguyên vật liệu",
    path: "/material/type",
  },
  Suggest: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "DS đề xuất nguyên vật liệu",
    path: "/material/suggest",
  },
  CreateMaterialSuggest: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Tạo đề xuất nguyên vật liệu",
    path: "/material/suggest/form",
  },
  UpdateMaterialSuggest: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Sửa đề xuất nguyên vật liệu",
    path: "/material/suggest/form/:code",
  },
  RawMaterial: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Nguyên vật liệu sơ chế",
    path: "/material/raw-material/list",
  },
  RawMaterialFormCreate: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Tạo mã sơ chế",
    path: "/material/raw-material/list/form",
  },
  RawMaterialFormUpdate: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Sửa mã sơ chế",
    path: "/material/raw-material/list/form/:id",
  },
  SemiFinishedProduct: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Bán thành phẩm",
    path: "/material/semi-finished-product/list",
  },
  SemiFinishedProductFormCreate: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Tạo bán thành phẩm",
    path: "/material/semi-finished-product/list/form",
  },
  SemiFinishedProductFormUpdate: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Sửa bán thành phẩm",
    path: "/material/semi-finished-product/list/form/:id",
  },
  PurchaseSemiFinishedProductsList: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "DS nhập NVL sơ chế",
    path: "/material/purchase-semi-finished-product/list",
  },
  PurchaseSemiFinishedProductCreate: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Tạo phiếu nhập NVL sơ chế",
    path: "/material/purchase-semi-finished-product/list/form",
  },
  PurchaseSemiFinishedProductUpdate: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Sửa phiếu nhập NVL sơ chế",
    path: "/material/purchase-semi-finished-product/list/form/:id",
  },
};
//#endregion

//#region Hàng hóa
export const HangHoa = {
  Industry: {
    required: {
      code: ENTITY_GROUP_CODE.HANG_HOA,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "DS ngành hàng hóa",
    path: "/goods/industries",
  },
  Group: {
    required: {
      code: ENTITY_GROUP_CODE.HANG_HOA,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "DS nhóm hàng hóa",
    path: "/goods/groups",
  },
  DeXuatMatHang: {
    required: {
      code: ENTITY_GROUP_CODE.HANG_HOA,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "DS đề xuất hàng hóa",
    path: "/goods/suggest-list",
  },
  MatHang: {
    required: {
      code: ENTITY_GROUP_CODE.HANG_HOA,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "DS mặt hàng",
    path: "/goods/list",
  },
  XemChiTietHangHoa: {
    required: {
      code: ENTITY_GROUP_CODE.HANG_HOA,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Chi tiết hàng hóa",
    path: "/goods/list/detail/:id",
  },
  BaoCaoDieuChinhGia: {
    required: {
      code: ENTITY_GROUP_CODE.HANG_HOA,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Báo cáo điều chỉnh giá",
    path: "/goods/price-reports",
  },
  BaoCaoDieuChinhDinhMuc: {
    required: {
      code: ENTITY_GROUP_CODE.HANG_HOA,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Báo cáo điều chỉnh định mức",
    path: "/goods/material-reports",
  },
  CreateDanhMucHangHoa: {
    required: {
      code: ENTITY_GROUP_CODE.HANG_HOA,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Tạo đề xuất hàng hóa",
    path: "/goods/form",
  },
  UpdateDanhMucHangHoa: {
    required: {
      code: ENTITY_GROUP_CODE.HANG_HOA,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Sửa đề xuất hàng hóa",
    path: "/goods/form/:code",
  },
  DeXuatGiaHangHoa: {
    required: {
      code: ENTITY_GROUP_CODE.HANG_HOA,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Đề xuất giá",
    path: "/goods/price-suggest/:code",
  },
  XemDeXuatHangHoa: {
    required: {
      code: ENTITY_GROUP_CODE.HANG_HOA,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Xem đề xuất HH",
    path: "/goods/view-suggest/:code",
  },
  DieuChinhGiaHangHoa: {
    required: {
      code: ENTITY_GROUP_CODE.HANG_HOA,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Điều chỉnh giá",
    path: "/goods/price-update/:code",
  },
  DieuChinhThongTinHangHoa: {
    required: {
      code: ENTITY_GROUP_CODE.HANG_HOA,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Điều chỉnh thông tin",
    path: "/goods/info-update/:code",
  },
  DieuChinhDinhMucHangHoa: {
    required: {
      code: ENTITY_GROUP_CODE.HANG_HOA,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Điều chỉnh định mức",
    path: "/goods/materials-update/:code",
  },
};
//#endregion

//#region Menu
export const Menu = {
  DanhSachMenu: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Danh sách menu",
    path: "/menus/list",
  },
  TaoMenu: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Tạo menu",
    path: "/menus/form",
  },
  SuaMenu: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Sửa menu",
    path: "/menus/form/:id",
  },
  ChiTietMenu: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Chi tiết menu",
    path: "/menus/detail/:id",
  },
};
//#endregion

//#region Phân quyền
export const Permission = {
  User: {
    required: {
      code: ENTITY_GROUP_CODE.CONFIGURATION,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Người dùng",
    path: "/permission/user",
  },
  Group: {
    required: {
      code: ENTITY_GROUP_CODE.ROLE,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Nhóm người dùng",
    path: "/permission/group",
  },
  Slip: {
    required: {
      code: ENTITY_GROUP_CODE.ROLE,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Danh sách phiếu",
    path: "/permission/slip",
  },
  Configuration: {
    required: {
      code: ENTITY_GROUP_CODE.CONFIGURATION,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Cấu hình",
    path: "/permission/configuration",
  },
  ApprovalConfiguration: {
    required: {
      code: ENTITY_GROUP_CODE.CONFIGURATION,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Cấu hình duyệt",
    path: "/permission/approval-configuration",
  },
  ExportedMaterialConfig: {
    required: {
      code: ENTITY_GROUP_CODE.CAU_HINH_XUAT_NVL,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Cấu hình NVL được xuất hàng",
    path: "/permission/exported-materials",
  },
};
//#endregion

//#region Đề xuất nhà cung cấp
export const DeXuatNhaCungCap = {
  DanhSachDeXuatNhaCungCap: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Danh sách đề xuất NCC",
    path: "/supplier-suggest/list",
  },
  DanhGiaDeXuatNhaCungCap: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Đánh giá đề xuất NCC",
    path: "/supplier-suggest/rating/:id",
  },
  ChamDiemDeXuatNhaCungCap: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Chấm điểm đề xuất NCC",
    path: "/supplier-suggest/rating/:id/supplier/:supplierId",
  },
  PhieuDeXuatNhaCungCap: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Phiếu đề xuất nhà cung cấp",
    path: "/supplier-suggest/form",
  },
  SuaPhieuDeXuatNhaCungCap: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Phiếu đề xuất nhà cung cấp",
    path: "/supplier-suggest/form/:id",
  },
};
//#endregion

//#region Nhà cung cấp
export const NhaCungCap = {
  DanhSachNhaCungCap: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "DS nhà cung cấp",
    path: "/suppliers/list",
  },
  DanhSachPhieuChamDiemNhaCungCap: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "DS phiếu chấm điểm NCC",
    path: "/supplier-rating/list",
  },
  ThemPhieuChamDiemNhaCungCap: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Phiếu chấm điểm NCC",
    path: "/supplier-rating/form",
  },
  SuaPhieuChamDiemNhaCungCap: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Phiếu chấm điểm NCC",
    path: "/supplier-rating/form/:id",
  },
  DanhSachNhaCungCapChamDiem: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "DS nhà cung cấp chấm điểm",
    path: "/supplier-rating/rating/:id",
  },
  ChamDiemNhaCungCap: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Chấm điểm nhà cung cấp",
    path: "/supplier-rating/rating/:id/supplier/:supplierId",
  },
};
//#endregion

//#region Chất lượng hàng hóa
export const ChatLuongHangHoa = {
  DanhSachPhieuChamDiemHangHoa: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Đánh giá chất lượng hàng hóa",
    path: "/quality-of-goods/rating-forms/list",
  },
  DanhSachHangHoaChamDiem: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "DS hàng hóa chấm điểm",
    path: "/quality-of-goods/rating/:id",
  },
  ChamDiemHangHoa: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Chấm điểm hàng hóa",
    path: "/quality-of-goods/rating/:id/:goodId",
  },
  ThemPhieuChamDiemHangHoa: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Thêm phiếu chấm điểm HH",
    path: "/quality-of-goods/rating-forms/create",
  },
  SuaPhieuChamDiemHangHoa: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Sửa phiếu chấm điểm HH",
    path: "/quality-of-goods/rating-forms/edit/:id",
  },
};
//#endregion

//#region Combo
export const Combo = {
  DanhMucComboItem: {
    required: {
      code: ENTITY_GROUP_CODE.COMBO_ITEM,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Danh mục Combo item",
    path: "/combos/combo-items",
  },
  ThemDeXuatCombo: {
    required: {
      code: ENTITY_GROUP_CODE.COMBO,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Thêm đề xuất Combo",
    path: "/combos/create-suggest",
  },
  ThemCombo: {
    required: {
      code: ENTITY_GROUP_CODE.COMBO,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Thêm Combo",
    path: "/combos/create",
  },
  ChiTietDeXuatCombo: {
    required: {
      code: ENTITY_GROUP_CODE.COMBO,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Chi Tiết Đề Xuất Combo",
    path: "/combos/proposal-detail/:id",
  },
  ChiTietCombo: {
    required: {
      code: ENTITY_GROUP_CODE.COMBO,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Chi Tiết Combo",
    path: "/combos/detail/:id",
  },
  SuaDeXuatCombo: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Sửa đề xuất Combo",
    path: "/combos/edit-suggest/:id",
  },
  DanhSachDeXuatCombo: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Danh sách đề xuất Combo",
    path: "/combos/suggest-list",
  },
  DanhSachCombo: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Danh sách Combo",
    path: "/combos/list",
  },
  SuaCombo: {
    required: {
      code: ENTITY_GROUP_CODE.MATERIAL_GROUP,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Sửa Combo",
    path: "/combos/edit/:id",
  },
};
//#endregion

//#region Kho
export const Warehouse = {
  DanhSachKho: {
    required: {
      code: ENTITY_GROUP_CODE.COMBO_ITEM,
      permission: PERMISSION_VALUE.READ,
    },
    icon: "",
    name: "Danh sách kho",
    path: "/warehouses",
  },
};
//#endregion
